<ion-header>
  <ion-toolbar class="modal-header">
    <ion-title *ngIf="priceFlag === 'price'" translate="PRICE_TITLE"></ion-title>
    <ion-title *ngIf="priceFlag === 'stock'" translate="STOCK_TITLE"></ion-title>
    <ion-buttons slot="end">
      <ion-button class="ion-text-capitalize" (click)="onSaveClick()" translate="SAVE"></ion-button>
      <ion-button class="ion-text-capitalize" (click)="onCloseClick()" translate="CLOSE"></ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>


<ion-content>
  <div *ngIf="priceFlag === 'price'" class="smartdine-form">
    <form [formGroup]="priceForm">
      <ion-list>
  
        <ion-item
          class="ion-color-danger ion-text-center errors"
          lines="full"
          *ngIf="priceForm.errors"
        >
          <ion-label>
            <div [innerText]="priceForm.errors?.lowerToDate"></div>
          </ion-label>
        </ion-item>
  
        <ion-item lines="full">
          <ion-label><span translate="PRICE"></span><span class="required-star">*</span></ion-label>
          <ion-input
            type="number"
            formControlName="price"
          ></ion-input>
        </ion-item>
        <small class="error-text" *ngIf="priceForm.get('price')?.touched && priceForm.get('price')?.errors?.required">
          Price is required
        </small>

        <ion-item lines="full">
          <ion-label><span translate="COST"></span><span class="required-star">*</span></ion-label>
          <ion-input
            type="number"
            formControlName="costPrice"
          ></ion-input>
        </ion-item>
        <small class="error-text" *ngIf="priceForm.get('costPrice')?.touched && priceForm.get('costPrice')?.errors?.required">
          Cost is required
        </small>

        <!-- From Date -->
        <ion-item lines="full">
          <ion-label><span translate="FROM_DATE"></span><span class="required-star">*</span></ion-label>
          <ion-datetime-button datetime="from-date-id"></ion-datetime-button>
        </ion-item>
        <ion-modal keepContentsMounted="true">
          <ng-template>
            <ion-datetime
              id="from-date-id"
              presentation="date"
              displayFormat="DD-MMM-YYYY"
              formControlName="fromDate"
              showDefaultButtons="true"
              doneText="Done"
              cancelText="Cancel"
            ></ion-datetime>
          </ng-template>
        </ion-modal>
  
        <!-- To Date -->
        <ion-item lines="full">
          <ion-label><span translate="TO_DATE"></span><span class="required-star">*</span></ion-label>
          <ion-datetime-button datetime="to-date-id"></ion-datetime-button>
        </ion-item>
        <ion-modal keepContentsMounted="true">
          <ng-template>
            <ion-datetime
              id="to-date-id"
              presentation="date"
              displayFormat="DD-MMM-YYYY"
              formControlName="toDate"
              showDefaultButtons="true"
              doneText="Done"
              cancelText="Cancel"
            ></ion-datetime>
          </ng-template>
        </ion-modal>
  
      </ion-list>
    </form>
  </div>
  
  <div *ngIf="priceFlag === 'stock'" class="smartdine-form">
    <form [formGroup]="stockForm">
      <ion-list>
  
        <ion-item lines="full">
          <ion-label><span translate="AVAIL_STOCK"></span><span class="required-star">*</span></ion-label>
          <ion-input type="number" formControlName="availableQuantity"></ion-input>
        </ion-item>
        <small class="error-text" *ngIf="stockForm?.get('availableQuantity')?.touched && stockForm.get('availableQuantity')?.errors?.required">
          Available Quantity is required
        </small>

        <ion-item lines="full">
          <ion-label><span translate="PLAN_STOCK"></span><span class="required-star">*</span></ion-label>
          <ion-input type="number" formControlName="totalQuantity"></ion-input>
        </ion-item>
  
        <small class="error-text" *ngIf="stockForm.get('totalQuantity')?.touched && stockForm.get('totalQuantity')?.errors?.required">
          Total Quantity is required
        </small>

        <!-- Stock Date -->
        <ion-item lines="full">
          <ion-label><span translate="DATE"></span><span class="required-star">*</span></ion-label>
          <ion-datetime-button datetime="stock-date-id"></ion-datetime-button>
        </ion-item>
        <ion-modal keepContentsMounted="true">
          <ng-template>
            <ion-datetime
              id="stock-date-id"
              presentation="date"
              displayFormat="DD-MMM-YYYY"
              formControlName="date"
              showDefaultButtons="true"
              doneText="Done"
              cancelText="Cancel"
            ></ion-datetime>
          </ng-template>
        </ion-modal>
  
        <ion-item lines="inset">
          <ion-label>
            <span translate="STOCK_CHECK"></span>
          </ion-label>
          <ion-toggle slot="end" formControlName="stockCheckEnabled"></ion-toggle>
        </ion-item>

      </ion-list>
    </form>
  </div>
  
  <ion-list class="price-history-list">
    <ion-item lines="none" class="price-history-header">
      <ion-label>
        <h3 class="text-secondary" translate="PRICE_HISTORY"></h3>
      </ion-label>
    </ion-item>
  
    <ion-item
      *ngFor="let history of itemPriceHistory; let i = index"
      lines="inset"
      [ngClass]="{ 'striped-row': i % 2 !== 0 }"
    >
      <ion-label class="price-history-label">
        <div class="row-content">
          <div class="date-range">
            {{ history?.fromDate | date: 'mediumDate' }}
            &nbsp;<span translate>TO</span>&nbsp;
            {{ history?.toDate | date: 'mediumDate' }}
          </div>
          <div class="price">
            <strong>{{ history?.currencyModel?.currencysymbol + '' + history?.price }}</strong>
          </div>
        </div>
      </ion-label>
    </ion-item>
  </ion-list>
  
  

</ion-content>
